export function  renderHeader(h, data) {
    return h("span", [
      h(
        "el-tooltip",
        {
          attrs: {
            class: "item",
            effect: "dark",
            content: data.column.label,
            placement: "top",
          },
        },
        [h("span", data.column.label)]
      ),
    ]);
  }